import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7c70a50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "app-shell-container navbar__inner" }
const _hoisted_3 = { class: "navbar__left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["aria-expanded", "onClick"]
const _hoisted_6 = ["aria-label", "title", "aria-expanded"]
const _hoisted_7 = {
  key: 0,
  class: "navbar__tenant-context"
}
const _hoisted_8 = { class: "navbar__tenant-context-label" }
const _hoisted_9 = { class: "navbar__tenant-context-name" }
const _hoisted_10 = {
  key: 0,
  class: "navbar__tenant-context-bin"
}
const _hoisted_11 = {
  key: 1,
  class: "navbar-dropdown dropdown"
}
const _hoisted_12 = ["data-name"]
const _hoisted_13 = { class: "navbar-link__badge" }
const _hoisted_14 = {
  key: 1,
  class: "navbar-dropdown dropdown"
}
const _hoisted_15 = ["data-name"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "bg-blue-500 text-white rounded-full px-2 flex" }
const _hoisted_18 = { style: {"font-size":"12px"} }
const _hoisted_19 = {
  key: 0,
  class: "navbar-dropdown dropdown"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["data-name"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "bg-blue-500 text-white rounded-full px-2 flex" }
const _hoisted_24 = { style: {"font-size":"12px"} }
const _hoisted_25 = ["aria-label", "title"]
const _hoisted_26 = { class: "navbar-link__badge" }
const _hoisted_27 = { class: "navbar__right" }
const _hoisted_28 = ["title", "aria-label"]
const _hoisted_29 = { class: "navbar__tenant-name" }
const _hoisted_30 = {
  key: 0,
  class: "navbar__notifications-count"
}
const _hoisted_31 = { class: "navbar__locale" }
const _hoisted_32 = { class: "navbar__locale-label" }
const _hoisted_33 = { class: "navbar__locale-short" }
const _hoisted_34 = {
  key: 0,
  class: "navbar__locale-menu dropdown"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "navbar__avatar" }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 1,
  class: "navbar__avatar-initials"
}
const _hoisted_39 = { class: "navbar__user-name" }
const _hoisted_40 = ["title", "aria-label"]
const _hoisted_41 = { class: "navbar__logout-text" }

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  watchEffect,
  onBeforeUpdate,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import logoUrl from "@/assets/logo.svg";
import ThemeToggle from "@/components/common/ThemeToggle.vue";

import { AuthGetters } from "@/store/modules/auth";
import { UserActions } from "@/store/modules/user/actions";
import { UserGetters } from "@/store/modules/user/getters";

import layoutRoutes from "./layoutRoutes";

import {
  LogoutIcon,
  HomeIcon,
  UserIcon,
  DocumentDuplicateIcon,
  CalendarIcon,
  SearchIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  BellIcon,
  MinusIcon,
  UserGroupIcon,
  ChatAlt2Icon,
  OfficeBuildingIcon,
  ViewGridIcon,
  MenuIcon,
  XIcon,
} from "@heroicons/vue/outline";
import { TransferAuthorityActions } from "@/store/modules/transferAuthority/actions";
import { RouteActions } from "@/store/modules/route";
import { NotificationGetters } from "@/store/modules/notification/getters";
import { NotificationActions } from "@/store/modules/notification/actions";
import { config } from "@/config";
import { getLocale, setLocale, t } from "@/i18n";
import HelpdeskDataService from "@/services/helpdesk/HelpdeskDataService";
import { leaveCurrentAccount } from "@/services/auth/AccountSessionService";
import EntityApprovalDataService from "@/services/common/entityApproval/EntityApprovalDataService";
import {
  HELPDESK_REALTIME_CONNECTED_EVENT,
  HELPDESK_REALTIME_EVENT,
  HelpdeskRealtimeEvent,
} from "@/services/helpdesk/HelpdeskRealtime";


export default /*#__PURE__*/_defineComponent({
  props: {
    templates: null,
    hasSections: null,
    sectionsOpen: null
  },
  emits: ["toggle-sections"],
  setup(__props: any, { emit }) {

const props = __props as {
  templates: any[];
  hasSections?: boolean;
  sectionsOpen?: boolean;
}

const store = useStore();
const router = useRouter();
const route = useRoute();


const sectionsTrigger = ref<HTMLButtonElement | null>(null);

const currentLocale = ref(getLocale());
const localeDropdown = ref(false);

const localeOptions = [
  { value: "ru" as const, label: "Русский" },
  { value: "en" as const, label: "English" },
];

const currentLocaleLabel = computed(
  () =>
    localeOptions.find((option) => option.value === currentLocale.value)
      ?.label || currentLocale.value
);

const onLocaleChange = (locale: "ru" | "en") => {
  setLocale(locale);
  currentLocale.value = locale;
  window.location.reload();
};

const onLocaleSelect = (locale: "ru" | "en") => {
  localeDropdown.value = false;
  if (currentLocale.value !== locale) {
    onLocaleChange(locale);
  }
};

const user = computed(() => store.getters[UserGetters.GET_PROFILE]);
const authIdentity = computed(
  () => store.getters[AuthGetters.GET_USER_IDENTITY]
);
const isHelpdeskManager = computed(
  () => authIdentity.value?.permissions?.includes("HELPDESK_MANAGE") === true
);
const newUnassignedTicketCount = ref(0);
const entityApprovalWaitingCount = ref(0);
const newUnassignedTicketCountLabel = computed(() =>
  newUnassignedTicketCount.value > 99
    ? "99+"
    : String(newUnassignedTicketCount.value)
);

const loadNewUnassignedTicketCount = async () => {
  if (!isHelpdeskManager.value) {
    newUnassignedTicketCount.value = 0;
    return;
  }

  try {
    const response = await HelpdeskDataService.getNewUnassignedCount();
    newUnassignedTicketCount.value = Math.max(0, Number(response.data) || 0);
  } catch {
    newUnassignedTicketCount.value = 0;
  }
};

const loadEntityApprovalWaitingCount = async () => {
  if (
    authIdentity.value?.permissions?.includes("ENTITY_APPROVAL_COORDINATE") !==
    true
  ) {
    entityApprovalWaitingCount.value = 0;
    return;
  }

  try {
    const response = await EntityApprovalDataService.getAll({ page: 1 });
    const data = response.data?.data;
    entityApprovalWaitingCount.value = Math.max(
      0,
      Number(
        data?.pager?.totalItems ?? data?.items?.length ?? data?.list?.length
      ) || 0
    );
  } catch {
    entityApprovalWaitingCount.value = 0;
  }
};

const handleHelpdeskRealtimeEvent = (event: Event) => {
  if (!isHelpdeskManager.value) {
    return;
  }

  const detail = (event as CustomEvent<HelpdeskRealtimeEvent>).detail;
  if (!detail) {
    return;
  }

  if (
    detail.eventType === "TICKET_CREATED" &&
    detail.status === "NEW" &&
    !detail.assigneeId
  ) {
    newUnassignedTicketCount.value += 1;
    return;
  }

  if (detail.previousStatus === "NEW" && detail.status !== "NEW") {
    newUnassignedTicketCount.value = Math.max(
      0,
      newUnassignedTicketCount.value - 1
    );
  }
};

const handleHelpdeskRealtimeConnected = () => {
  void loadNewUnassignedTicketCount();
};

watch(
  isHelpdeskManager,
  (manager) => {
    if (manager) {
      void loadNewUnassignedTicketCount();
    } else {
      newUnassignedTicketCount.value = 0;
    }
  },
  { immediate: true }
);

const userFullName = computed(() => {
  const profile = user.value || authIdentity.value;
  if (!profile) {
    return "";
  }

  const name = [profile.surname, profile.name, profile.middleName]
    .filter(Boolean)
    .join(" ");

  return name || profile.login || "";
});

const userInitials = computed(() => {
  const profile = user.value || authIdentity.value;
  if (!profile) {
    return "";
  }

  const parts = [profile.surname, profile.name].filter(Boolean);
  if (!parts.length) {
    return "";
  }

  return parts
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
});

const profileImage = ref("");

async function loadProfileImage() {
  await store.dispatch(UserActions.PROFILE);

  if (!user.value?.imageGuid) {
    profileImage.value = "";
    return;
  }

  try {
    const result = await store.dispatch(UserActions.PROFILE_IMAGE_DOWNLOAD, {
      imageGuid: user.value.imageGuid,
    });
    profileImage.value = result.data?.fileData || "";
  } catch {
    profileImage.value = "";
  }
}

const icons: Record<any, any> = {
  PROFILE: UserIcon,
  MY_DOC: DocumentDuplicateIcon,
  FIND_DOCUMENT: SearchIcon,
  REPORTS: CalendarIcon,
};

const logout = () => {
  void leaveCurrentAccount(store);
};

const myDocDropdown = ref(false);
const taskDropdown = ref(false);
const panelDropdown = ref(false);
const togglePanelDropdown = () => {
  panelDropdown.value = !panelDropdown.value;
  myDocDropdown.value = false;
  taskDropdown.value = false;
};
const mobileMenuOpen = ref(false);

const layoutTemplate = computed(() => props.templates);
const hiddenTopMenuCodes = new Set([
  "CREATE_DOCUMENT",
  "ARCHIVE",
  "PROFILE",
  "FIND_DOCUMENT",
  "REPORTS",
  "DOCUMENT_STRUCTURE",
  "HR",
  "SYSTEM_CONFIG",
  "EDMS_LOGS",
]);

const documentMenuLabels: Record<string, string> = {
  MY_DOC_FAVORITE: t("navbar.favorite"),
  MY_DOC_NEW: t("navbar.drafts"),
  MY_DOC_REWORK: t("navbar.rework"),
  MY_DOC_PROCESS: t("navbar.processes"),
};

const taskMenuLabelsByName: Record<string, string> = {
  "на доработку": t("layout.taskForRework"),
  доработка: t("layout.taskForRework"),
  "на подписание": t("layout.taskForSigning"),
  подписание: t("layout.taskForSigning"),
  "на согласование": t("layout.taskForApproval"),
  согласование: t("layout.taskForApproval"),
  "на ознакомление": t("layout.taskForReview"),
  ознакомление: t("layout.taskForReview"),
  "на исполнение": t("layout.taskForExecution"),
  исполнение: t("layout.taskForExecution"),
};

const getTaskMenuName = (name: string | undefined) => {
  const menuName = name || "";
  return taskMenuLabelsByName[menuName.trim().toLowerCase()] || menuName;
};

const topMenuTemplates = computed(() =>
  layoutTemplate.value.filter(
    (template: any) =>
      template.hasAccess && !hiddenTopMenuCodes.has(template.code)
  )
);

const currentRoutePath = computed<string>(() => {
  return route.fullPath;
});

const documentRoutes = ref([]);
onBeforeUpdate(() => {
  documentRoutes.value = [];
});

watch(
  () => currentRoutePath.value,
  () => {
    myDocDropdown.value = false;
    taskDropdown.value = false;
    mobileMenuOpen.value = false;
    if (route.name === "DocumentList") {
      store.dispatch(
        RouteActions.SET_ROUTE_NAME,
        documentRoutes.value[currentRoutePath.value]
          ? documentRoutes.value[currentRoutePath.value].dataset.name
          : ""
      );
    }
  }
);

const closeNavDropdowns = () => {
  panelDropdown.value = false;
  myDocDropdown.value = false;
  taskDropdown.value = false;
  mobileMenuOpen.value = false;
};

watch(
  () => props.sectionsOpen,
  (open, wasOpen) => {
    if (open) closeNavDropdowns();
    if (wasOpen && !open) nextTick(() => sectionsTrigger.value?.focus());
  }
);

const toggleMobileMenu = () => {
  const open = !mobileMenuOpen.value;
  if (open && props.sectionsOpen) emit("toggle-sections");
  closeNavDropdowns();
  mobileMenuOpen.value = open;
};

const onNavClick = (event: MouseEvent) => {
  if ((event.target as HTMLElement).closest("a")) {
    closeNavDropdowns();
  }
};

const toggleMyDocDropdown = () => {
  myDocDropdown.value = !myDocDropdown.value;
  taskDropdown.value = false;
};

const toggleTaskDropdown = () => {
  taskDropdown.value = !taskDropdown.value;
  myDocDropdown.value = false;
};

const toastCount = computed(() => {
  return store.getters[NotificationGetters.GET_NOTIFICATION_COUNT];
});

const openAllTasks = async () => {
  taskDropdown.value = false;
  await store.dispatch(RouteActions.SET_ROUTE_NAME, "");
  await router.push(layoutRoutes.MY_DOC_PROCESS);
};
const clickDocElement = async (child) => {
  myDocDropdown.value = false;
  taskDropdown.value = false;
  if (child.code === "MY_DOC_PROCESS" || child.code === "MY_DOC") {
    await store.dispatch(RouteActions.SET_ROUTE_NAME, child.name || "");
  }
  await router.push(documentMenuPath(child));
};

const documentMenuPath = (child: any) => {
  if (!child.code || !(child.code in layoutRoutes)) return "/404";
  const params = new URLSearchParams();
  if (child.templateId) params.set("templateId", String(child.templateId));
  if (child.type) params.set("type", String(child.type));
  if (child.status) params.set("status", String(child.status));
  const query = params.toString();
  return `${layoutRoutes[child.code]}${query ? `?${query}` : ""}`;
};

const documentMenuChildren = (template: any) => {
  const allDocumentsItem = {
    code: "MY_DOC",
    name: t("layout.allDocuments"),
    type: "ALL",
    hasAccess: true,
  };
  const statusItems = [
    {
      code: "MY_DOC",
      name: t("status.document.success"),
      type: "ALL",
      status: "SUCCESS",
      hasAccess: true,
    },
    {
      code: "MY_DOC",
      name: t("status.document.process"),
      type: "ALL",
      status: "PROCESS",
      hasAccess: true,
    },
    {
      code: "MY_DOC",
      name: t("status.document.denied"),
      type: "ALL",
      status: "DENIED",
      hasAccess: true,
    },
  ];

  const children = (template.childs || [])
    .filter(
      (child: any) =>
        child.hasAccess &&
        child.code !== "MY_DOC_PROCESS" &&
        child.code !== "MY_DOC_REWORK" &&
        child.code !== "MY_DOC_TRACKING"
    )
    .filter((child: any) => !(child.code === "MY_DOC" && child.type === "ALL"))
    .map((child: any) => ({
      ...child,
      name: documentMenuLabels[child.code] || child.name,
    }));

  return [allDocumentsItem, ...statusItems, ...children];
};

const myDocTemplate = computed(() =>
  layoutTemplate.value.find((template: any) => template.code === "MY_DOC")
);

const tasksMenuVisible = computed(() =>
  Boolean(myDocTemplate.value?.hasAccess)
);

const transferAuthorityPendingCount = ref(0);
const transferAuthorityActiveCount = ref(0);
const transferAuthorityMenuVisible = computed(
  () =>
    transferAuthorityPendingCount.value > 0 ||
    transferAuthorityActiveCount.value > 0
);

const loadTransferAuthoritySummary = async () => {
  try {
    const summary = await store.dispatch(
      TransferAuthorityActions.FETCH_INBOX_SUMMARY
    );
    transferAuthorityPendingCount.value = Number(summary?.pendingCount ?? 0);
    transferAuthorityActiveCount.value = Number(summary?.activeCount ?? 0);
  } catch (error) {
    transferAuthorityPendingCount.value = 0;
    transferAuthorityActiveCount.value = 0;
  }
};

watch(
  () => toastCount.value,
  () => {
    loadTransferAuthoritySummary();
    loadEntityApprovalWaitingCount();
  }
);

const controlPanelOrder = [
  "USER",
  "COMPANY",
  "DOCUMENT_TEMPLATE",
  "DOCUMENT_CONSTRUCTOR",
  "ENTITY_APPROVAL",
  "REPORTS",
  "DOCUMENT_STRUCTURE",
  "NOMENCLATURE",
  "JOB",
  "PROCESS_TEMPLATE",
  "ROLE",
  "EDMS_LOGS",
];

const controlPanelLabels: Record<string, string> = {
  USER: t("navbar.users"),
  COMPANY: t("navbar.companies"),
  DOCUMENT_TEMPLATE: t("navbar.templates"),
  DOCUMENT_CONSTRUCTOR: t("navbar.categories"),
  ENTITY_APPROVAL: t("navbar.entityApproval"),
  REPORTS: t("navbar.reports"),
  DOCUMENT_STRUCTURE: t("navbar.structures"),
  NOMENCLATURE: t("navbar.nomenclatures"),
  JOB: t("navbar.positions"),
  PROCESS_TEMPLATE: t("navbar.processes"),
  ROLE: t("navbar.roles"),
  EDMS_LOGS: t("navbar.logs"),
};

const controlPanelChildren = (template: any) => {
  const existing = (template.childs || []).filter(
    (child: any) => child.hasAccess
  );
  const manual = [
    {
      code: "ENTITY_APPROVAL",
      name: controlPanelLabels.ENTITY_APPROVAL,
      hasAccess:
        authIdentity.value?.permissions?.includes(
          "ENTITY_APPROVAL_COORDINATE"
        ) === true,
    },
    {
      code: "DOCUMENT_STRUCTURE",
      name: controlPanelLabels.DOCUMENT_STRUCTURE,
      hasAccess: true,
    },
    {
      code: "REPORTS",
      name: controlPanelLabels.REPORTS,
      hasAccess: true,
    },
  ];

  const byCode = new Map<string, any>();
  [...existing, ...manual.filter((child: any) => child.hasAccess)].forEach(
    (child: any) => {
      if (!controlPanelOrder.includes(child.code)) {
        return;
      }

      byCode.set(child.code, {
        ...child,
        name: controlPanelLabels[child.code] || child.name,
        notificationCount:
          child.code === "ENTITY_APPROVAL"
            ? entityApprovalWaitingCount.value
            : child.notificationCount,
      });
    }
  );

  return controlPanelOrder.map((code) => byCode.get(code)).filter(Boolean);
};

const taskMenuChildren = computed(() => {
  return (myDocTemplate.value?.childs || [])
    .filter(
      (child: any) =>
        child.hasAccess &&
        layoutRoutes[child.code] === layoutRoutes.MY_DOC_PROCESS
    )
    .map((child: any) => ({
      ...child,
      name: getTaskMenuName(child.name),
    }));
});

watch(
  [() => route.name, () => route.query.templateId, taskMenuChildren],
  ([routeName, templateId, children]) => {
    if (routeName !== "ProcessUsersList") {
      return;
    }
    const activeChild = (children as any[]).find(
      (child: any) => String(child.templateId) === String(templateId || "")
    );
    store.dispatch(RouteActions.SET_ROUTE_NAME, activeChild?.name || "");
  },
  { immediate: true }
);

watchEffect(() => {
  const processInfoNotifications =
    store.getters[NotificationGetters.GET_PROCESS_INFO_NOTIFICATIONS];

  layoutTemplate.value.forEach((item: any) => {
    if (item.code === "MY_DOC") {
      processInfoNotifications.forEach((processInfoNotification: any) => {
        item.childs.forEach((child: any) => {
          if (processInfoNotification.templateId === child.templateId) {
            child.notificationCount = processInfoNotification.count;
          }
        });
      });
    }
  });
});

onMounted(async () => {
  window.addEventListener(HELPDESK_REALTIME_EVENT, handleHelpdeskRealtimeEvent);
  window.addEventListener(
    HELPDESK_REALTIME_CONNECTED_EVENT,
    handleHelpdeskRealtimeConnected
  );

  await loadTransferAuthoritySummary();
  await loadEntityApprovalWaitingCount();
  await loadProfileImage();
});

onBeforeUnmount(() => {
  window.removeEventListener(
    HELPDESK_REALTIME_EVENT,
    handleHelpdeskRealtimeEvent
  );
  window.removeEventListener(
    HELPDESK_REALTIME_CONNECTED_EVENT,
    handleHelpdeskRealtimeConnected
  );
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _unref(layoutRoutes).DASHBOARD,
          class: "navbar__logo",
          "aria-label": "Home"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(logoUrl),
              alt: "",
              class: "navbar__logo-image"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("button", {
          type: "button",
          class: "navbar__menu-toggle",
          "aria-label": "Navigation",
          "aria-expanded": mobileMenuOpen.value,
          onClick: _withModifiers(toggleMobileMenu, ["stop"])
        }, [
          (mobileMenuOpen.value)
            ? (_openBlock(), _createBlock(_unref(XIcon), { key: 0 }))
            : (_openBlock(), _createBlock(_unref(MenuIcon), { key: 1 }))
        ], 8, _hoisted_5),
        (__props.hasSections)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              ref: (_value, _refs) => {
                _refs['sectionsTrigger'] = _value
                sectionsTrigger.value = _value
              },
              type: "button",
              class: "navbar__sections-toggle",
              "aria-label": _unref(t)('layout.sections'),
              title: _unref(t)('layout.sections'),
              "aria-expanded": __props.sectionsOpen,
              "aria-controls": "app-module-navigation",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-sections')))
            }, [
              _createVNode(_unref(ViewGridIcon))
            ], 8, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("nav", {
          class: _normalizeClass(["navbar__nav", { 'navbar__nav--open': mobileMenuOpen.value }]),
          onClick: onNavClick
        }, [
          (_unref(authIdentity)?.tenant)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("layout.currentCompany")), 1),
                _createElementVNode("strong", _hoisted_9, _toDisplayString(_unref(authIdentity).tenant.name), 1),
                (_unref(authIdentity).tenant.bin)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(authIdentity).tenant.bin), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: _unref(layoutRoutes).DASHBOARD,
            class: _normalizeClass(["navbar-link", { 'navbar-link--active': _unref(route).name === 'Dashboard' }])
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(HomeIcon)), { class: "navbar-link__icon" })),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("navbar.home")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topMenuTemplates), (template) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: template.name
            }, [
              (!template.childs)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: _normalizeClass(["navbar-link", {
                'navbar-link--active':
                  _unref(layoutRoutes)[template.code] +
                    (template.templateId
                      ? '?templateId=' + template.templateId
                      : '') +
                    (template.type ? '?type=' + template.type : '') ===
                  _unref(currentRoutePath),
              }]),
                    to: 
                template.code && template.code in _unref(layoutRoutes)
                  ? _unref(layoutRoutes)[template.code]
                  : '/404'
              
                  }, {
                    default: _withCtx(() => [
                      (template.code in icons)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(icons[template.code]), {
                            key: 0,
                            class: "navbar-link__icon"
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(template.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "to"]))
                : (template.code === 'SYSTEM_CONFIG')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["navbar-link navbar-link--dropdown", {
                  'navbar-link--active':
                    _unref(layoutRoutes)[template.code] +
                      (template.templateId
                        ? '?templateId=' + template.templateId
                        : '') +
                      (template.type ? '?type=' + template.type : '') ===
                    _unref(currentRoutePath),
                }]),
                      onClick: togglePanelDropdown
                    }, [
                      (template.code in icons)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(icons[template.code]), {
                            key: 0,
                            class: "navbar-link__icon"
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("navbar.control")) + " ", 1),
                      _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChevronUpIcon)), { class: "navbar-link__chevron" }, null, 512)), [
                        [_vShow, template.code === 'SYSTEM_CONFIG' && panelDropdown.value]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChevronDownIcon)), { class: "navbar-link__chevron" }, null, 512)), [
                        [_vShow, template.code === 'SYSTEM_CONFIG' && !panelDropdown.value]
                      ]),
                      (panelDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlPanelChildren(template), (child) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: child.name,
                                ref: 
                        (el) => {
                          if (el)
                            documentRoutes.value[
                              _unref(layoutRoutes)[child.code] +
                                (child.templateId
                                  ? '?templateId=' + child.templateId
                                  : '') +
                                (child.type ? '?type=' + child.type : '')
                            ] = el;
                        }
                      ,
                                "data-name": child.name
                              }, [
                                _createVNode(_component_router_link, {
                                  class: _normalizeClass(["dropdown-item", {
                          'dropdown-item--active':
                            _unref(layoutRoutes)[child.code] +
                              (child.templateId
                                ? '?templateId=' + child.templateId
                                : '') +
                              (child.type ? '?type=' + child.type : '') ===
                            _unref(currentRoutePath),
                        }]),
                                  to: 
                          child.code && child.code in _unref(layoutRoutes)
                            ? _unref(layoutRoutes)[child.code] +
                              (child.templateId
                                ? '?templateId=' + child.templateId
                                : '') +
                              (child.type ? '?type=' + child.type : '')
                            : '/404'
                        
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(child.name) + " ", 1),
                                    _withDirectives(_createElementVNode("div", _hoisted_13, [
                                      _createVNode(_unref(BellIcon), { class: "navbar-link__badge-icon" }),
                                      _createElementVNode("span", null, _toDisplayString(child.notificationCount), 1)
                                    ], 512), [
                                      [_vShow, child.notificationCount]
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["class", "to"])
                              ], 8, _hoisted_12))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  : (template.code === 'MY_DOC')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["navbar-link navbar-link--dropdown", {
                  'navbar-link--active': _unref(route).name === 'DocumentList',
                }]),
                        onClick: toggleMyDocDropdown
                      }, [
                        (template.code in icons)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(icons[template.code]), {
                              key: 0,
                              class: "navbar-link__icon"
                            }))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("navbar.documents")) + " ", 1),
                        _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChevronUpIcon)), { class: "navbar-link__chevron" }, null, 512)), [
                          [_vShow, template.code === 'MY_DOC' && myDocDropdown.value]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChevronDownIcon)), { class: "navbar-link__chevron" }, null, 512)), [
                          [_vShow, template.code === 'MY_DOC' && !myDocDropdown.value]
                        ]),
                        (myDocDropdown.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentMenuChildren(template), (child) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: documentMenuPath(child),
                                  ref: 
                        (el) => {
                          if (el) documentRoutes.value[documentMenuPath(child)] = el;
                        }
                      ,
                                  "data-name": child.name
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["dropdown-item", {
                          'dropdown-item--active':
                            documentMenuPath(child) === _unref(currentRoutePath),
                        }]),
                                    onClick: _withModifiers(($event: any) => (clickDocElement(child)), ["stop"])
                                  }, [
                                    _createTextVNode(_toDisplayString(child.name) + " ", 1),
                                    _withDirectives(_createElementVNode("div", null, [
                                      _createVNode(_component_router_link, { to: "/notifications" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_17, [
                                            _createVNode(_unref(BellIcon), { style: {"width":"14px","margin-right":"2px"} }),
                                            _createElementVNode("div", _hoisted_18, _toDisplayString(child.notificationCount), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 512), [
                                      [_vShow, child.notificationCount]
                                    ])
                                  ], 10, _hoisted_16)
                                ], 8, _hoisted_15))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_unref(tasksMenuVisible))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["navbar-link navbar-link--dropdown", {
              'navbar-link--active': _unref(route).name === 'ProcessUsersList',
            }]),
                onClick: toggleTaskDropdown
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(DocumentDuplicateIcon)), { class: "navbar-link__icon" })),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("layout.myTasks")) + " ", 1),
                _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChevronUpIcon)), { class: "navbar-link__chevron" }, null, 512)), [
                  [_vShow, taskDropdown.value]
                ]),
                _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChevronDownIcon)), { class: "navbar-link__chevron" }, null, 512)), [
                  [_vShow, !taskDropdown.value]
                ]),
                (taskDropdown.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["dropdown-item", {
                    'dropdown-item--active':
                      _unref(route).name === 'ProcessUsersList' &&
                      !_unref(route).query.templateId,
                  }]),
                        onClick: _withModifiers(openAllTasks, ["stop"])
                      }, _toDisplayString(_ctx.$t("layout.allTasks")), 11, _hoisted_20),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taskMenuChildren), (child) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: child.name,
                          ref: 
                    (el) => {
                      if (el)
                        documentRoutes.value[
                          _unref(layoutRoutes)[child.code] +
                            (child.templateId
                              ? '?templateId=' + child.templateId
                              : '') +
                            (child.type ? '?type=' + child.type : '')
                        ] = el;
                    }
                  ,
                          "data-name": child.name
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["dropdown-item", {
                      'dropdown-item--active':
                        _unref(layoutRoutes)[child.code] +
                          (child.templateId
                            ? '?templateId=' + child.templateId
                            : '') +
                          (child.type ? '?type=' + child.type : '') ===
                        _unref(currentRoutePath),
                    }]),
                            onClick: _withModifiers(($event: any) => (clickDocElement(child)), ["stop"])
                          }, [
                            _createTextVNode(_toDisplayString(child.name) + " ", 1),
                            _withDirectives(_createElementVNode("div", null, [
                              _createVNode(_component_router_link, { to: "/notifications" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_unref(BellIcon), { style: {"width":"14px","margin-right":"2px"} }),
                                    _createElementVNode("div", _hoisted_24, _toDisplayString(child.notificationCount), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ], 512), [
                              [_vShow, child.notificationCount]
                            ])
                          ], 10, _hoisted_22)
                        ], 8, _hoisted_21))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (_unref(isHelpdeskManager))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: _unref(layoutRoutes).HELPDESK,
                class: _normalizeClass(["navbar-link", { 'navbar-link--active': _unref(route).name === 'Helpdesk' }])
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChatAlt2Icon)), { class: "navbar-link__icon" })),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("navbar.helpdesk")) + " ", 1),
                  (newUnassignedTicketCount.value > 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "navbar-link__badge navbar-link__badge--count",
                        "aria-label": `${_ctx.$t(
                'navbar.newHelpdeskTickets'
              )}: ${newUnassignedTicketCount.value}`,
                        title: `${_ctx.$t(
                'navbar.newHelpdeskTickets'
              )}: ${newUnassignedTicketCount.value}`
                      }, _toDisplayString(_unref(newUnassignedTicketCountLabel)), 9, _hoisted_25))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to", "class"]))
            : _createCommentVNode("", true),
          (_unref(transferAuthorityMenuVisible))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                class: _normalizeClass(["navbar-link", {
              'navbar-link--active': _unref(route).name === 'TransferAuthority',
            }]),
                to: { name: 'TransferAuthority', query: { type: 'IOUSER' } }
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(UserGroupIcon)), { class: "navbar-link__icon" })),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("transferAuthority.menuTitle")) + " ", 1),
                  _withDirectives(_createElementVNode("div", _hoisted_26, [
                    _createVNode(_unref(BellIcon), { class: "navbar-link__badge-icon" }),
                    _createElementVNode("span", null, _toDisplayString(transferAuthorityPendingCount.value), 1)
                  ], 512), [
                    [_vShow, transferAuthorityPendingCount.value]
                  ])
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_unref(authIdentity) && !_unref(isHelpdeskManager))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                to: _unref(layoutRoutes).HELPDESK,
                class: _normalizeClass(["navbar-link", { 'navbar-link--active': _unref(route).name === 'Helpdesk' }])
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ChatAlt2Icon)), { class: "navbar-link__icon" })),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("navbar.myTickets")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"]))
            : _createCommentVNode("", true)
        ], 2)
      ], 512), [
        [_directive_click_outside, closeNavDropdowns]
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(ThemeToggle),
        (_unref(authIdentity)?.tenant)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "navbar__tenant",
              title: `${_unref(authIdentity).tenant.name}${_unref(authIdentity).tenant.bin ? ' · ' + _unref(authIdentity).tenant.bin : ''}`,
              "aria-label": _ctx.$t('layout.currentCompany') + ': ' + _unref(authIdentity).tenant.name
            }, [
              _createVNode(_unref(OfficeBuildingIcon), { class: "navbar__tenant-icon" }),
              _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(authIdentity).tenant.name), 1)
            ], 8, _hoisted_28))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: "/notifications",
          class: "navbar__notifications"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BellIcon), { class: "navbar__notifications-icon" }),
            (_unref(toastCount))
              ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(toastCount)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("div", _hoisted_31, [
          _createElementVNode("button", {
            type: "button",
            class: "navbar__locale-trigger",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (localeDropdown.value = !localeDropdown.value))
          }, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(currentLocaleLabel)), 1),
            _createElementVNode("span", _hoisted_33, _toDisplayString(currentLocale.value.toUpperCase()), 1),
            _createVNode(_unref(ChevronDownIcon), { class: "navbar__locale-chevron" })
          ]),
          (localeDropdown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(localeOptions, (option) => {
                  return _createElementVNode("button", {
                    key: option.value,
                    type: "button",
                    class: _normalizeClass(["dropdown-item", {
                'dropdown-item--active': currentLocale.value === option.value,
              }]),
                    onClick: ($event: any) => (onLocaleSelect(option.value))
                  }, _toDisplayString(option.label), 11, _hoisted_35)
                }), 64))
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_click_outside, () => (localeDropdown.value = false)]
        ]),
        _createVNode(_component_router_link, {
          class: "navbar__user",
          to: { name: 'Profile' },
          title: _unref(userFullName),
          "aria-label": _unref(userFullName)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              (profileImage.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: `data:image/png;base64, ${profileImage.value}`,
                    alt: "",
                    class: "navbar__avatar-image"
                  }, null, 8, _hoisted_37))
                : (_unref(userInitials))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_unref(userInitials)), 1))
                  : (_openBlock(), _createBlock(_unref(UserIcon), {
                      key: 2,
                      class: "navbar__avatar-icon"
                    }))
            ]),
            _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(userFullName)), 1)
          ]),
          _: 1
        }, 8, ["title", "aria-label"]),
        _createElementVNode("button", {
          type: "button",
          class: "navbar__logout",
          title: _ctx.$t('layout.logout'),
          "aria-label": _ctx.$t('layout.logout'),
          onClick: logout
        }, [
          _createVNode(_unref(LogoutIcon), { class: "navbar__logout-icon" }),
          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("layout.logout")), 1)
        ], 8, _hoisted_40)
      ])
    ])
  ]))
}
}

})